<template>
  <div :class="{'animationComplete' : animationComplete}">
    <BackgroundFader class="blurable" ref="bgFader" :content="images" @complete="animationComplete = true;"/>
    <PageWrapper class="blurable">

      <InfoBlock :subTitle="gd[currentScenario].subTitle" :title="gd[currentScenario].title" :content="gd[currentScenario].steps[currentStep]"/>

      <Button btnContent="Replay animation" iconType="replay" @click="replay" class="replayButton reveal" />
      
      <Button class="scenarioNextButton" btnContent="Next step" iconType="arrow" @click="$router.push('step4')"/>
      <Button class="scenarioPreviousButton" iconType="arrow" @click="$router.push('step2')"/>
      <Button btnContent="Gallery" @click="openGallery" class="galleryButton" />
    
    </PageWrapper>

    <HotspotsWrapper class="blurable reveal">
      <Hotspot x="1180" y="650" @click="openModel('modelWindow1')"/>
    </HotspotsWrapper>

    <ModelWindow ref="modelWindow1">
      <h1>CBRN overpressuring system</h1>
      <p>Overpressure systems press air into the vehicle through filters. Vehicles are not perfectly airtight but the system has the capacity to keep a positive pressure level inside the vehicles using filtered air. Some systems also provide filtered air to the masks worn by the vehicle crews. The CBRN agents are filtered out and the crew is relatively safe as long as they remain in the vehicle.</p>
    </ModelWindow>

    <GalleryModal ref="galleryModal" :content="galleryImages"/>
  </div>
</template>


<script>
import PageWrapper from '@/components/PageWrapper';
import InfoBlock from '@/components/InfoBlock';
import AutoStep from '@/components/AutoStep';
import Button from '@/components/Button';
import ModelWindow from "@/components/ModelWindow";
import HotspotsWrapper from '@/components/HotspotsWrapper';
import Hotspot from '@/components/Hotspot';
import BackgroundFader from "@/components/BackgroundFader";
import gd from "@/assets/stores/globalDS.js";
import GalleryModal from '@/components/paul/GalleryModal';

export default {
  components: {
    PageWrapper,
    InfoBlock,
    AutoStep,
    Button,
    ModelWindow,
    HotspotsWrapper,
    Hotspot,
    BackgroundFader,
    GalleryModal
  },
  data() {
    return {
      gd: gd,
      animationComplete: false,
      images: [
        'military/3-1.jpg',
        'military/3-2.jpg'
      ],
      galleryImages: gd.gallery.military
    }
  },
  computed: {
    appPath() {
      return this.$router.currentRoute.fullPath.split("/");
    },
    currentStep() {
      return this.appPath[this.appPath.length - 1];
    },
    currentScenario() {
      return this.appPath[this.appPath.length - 2];
    }
  },
  methods: {
    replay() {
      this.animationComplete = false;
      this.$refs.bgFader.reset();
    },
    openModel: function(modelWindow) {
      this.$refs[modelWindow].openModel();
    },
    openGallery: function() {
      this.$refs.galleryModal.openModal();
    }
  }
}
</script>

